export default [
    {
      title: 'Payment',
      icon: 'CheckCircleIcon',
      tagVariant: 'light-danger',
      route:'payment'
    },
  ]
  